<template>
  <div style="border-style: groove; padding: 5px; margin-bottom: 5px">
    <div v-if="isEdit">
      <div class="columns">
        <input type="hidden" value="" v-model="conditions.id" />

        <!-- Travel Attribute Field-->
        <div class="column is-4">
          <b-field label="Travel Attribute">
            <b-select
              placeholder="Select Travel Attribute"
              v-model="selectedAttribute"
              required
            >
              <option value="">--Select Travel Attribute--</option>
              <option
                v-for="item in getTravelAttributes"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </b-select>
          </b-field>
        </div>
        <!-- End Travel Attribute Field-->

        <!-- Comparision Operator  Field-->

        <div class="column is-3" v-if="selectedAttribute">
          <b-field label="Comparison Operator">
            <b-select
              v-model="conditions.comparison.operator"
              placeholder="Select Comparison Operator"
              required
            >
              <option
                v-for="(item,
                key) in selectedTravelAttributeDetails.operators.split(';')"
                :key="key"
                :value="item"
              >
                {{ $helpers.getComparisionLabel(item).toUpperCase() }}
              </option>
            </b-select>
          </b-field>
        </div>

        <!-- End Comparision Operator Field-->

        <!-- Comparision Value Field-->

        <div class="column is-3" v-if="selectedAttribute">
          <b-field
            label="Comparison Value"
            v-if="selectedTravelAttributeDetails.type == 'Text'"
          >
            <b-input
              v-model="conditions.comparison.value"
              placeholder="Comparison Value"
            ></b-input>
          </b-field>
          <span class="help is-info" v-if="isList"
            >Enter comma seperated list of values.</span
          >

          <b-field label="Comparison Value" v-if="isDurationField">
            <div class="columns">
              <b-numberinput
                class="column"
                placeholder="Hours"
                :controls="false"
                v-model="conditions.comparison.value1"
              ></b-numberinput>

              &nbsp;
              <b-numberinput
                class="column"
                placeholder="Minutes"
                :controls="false"
                required
                v-model="conditions.comparison.value2"
              ></b-numberinput>
            </div>
            <b-input
              type="hidden"
              v-model="conditions.comparison.value"
            ></b-input>
          </b-field>

          <b-field label="Comparison Value" v-if="isNumberField">
            <b-numberinput
              placeholder="Enter Numeric value"
              :controls="false"
              v-model="conditions.comparison.value"
            ></b-numberinput>
          </b-field>

          <b-field
            label="Comparison Value"
            v-if="selectedTravelAttributeDetails.type == 'Date'"
          >
            <b-datepicker
              v-bind:value="valueAsDate"
              position="is-bottom-left"
              placeholder="Select a date..."
              icon="calendar-today"
              locale="en-US"
              v-on:input="valueChanged($event)"
              trap-focus
            >
            </b-datepicker>
          </b-field>
        </div>

        <!--End  Comparision Value Field-->

        <!--Comparision Value Units Field-->

        <div class="column is-2" v-if="selectedAttribute">
          <b-field
            label="Comparison Units"
            v-if="selectedTravelAttributeDetails.units"
          >
            <b-select
              required
              v-model="conditions.comparison.valueUnits"
              placeholder="Select Comparison Units"
            >
              <option
                v-for="(item,
                key) in selectedTravelAttributeDetails.units.split(';')"
                :key="key"
                :value="item"
                v-bind:selected="key == 0"
              >
                {{ item | capitalize }}
              </option>
            </b-select>
          </b-field>
        </div>

        <!-- End Comparision Value Units Field-->
      </div>
      <div>
        <span>
          <b-button @click="remove()">Cancel</b-button>&nbsp;

          <b-button :disabled="!isFormValid" @click="save" type="is-success">Save Condition</b-button>
        </span>
      </div>
    </div>
    <div class="columns" v-else>
      <div class="column is-10">
        {{ conditions.message }}
      </div>
      <div class="column is-1">
        <a @click="isEdit = !isEdit">
          Edit
        </a>
      </div>
      <div class="column is-1">
        <a v-if="conditions.id" @click="remove(conditions.id)">
          Delete
        </a>
        <a v-else @click="remove(conditions.uid)"> Delete </a>
      </div>
    </div>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.27.0/moment.min.js"></script>

<script>
var moment = require("moment"); // require

export default {
  name: "CustomCondition",
  props: {
    mode: String,
    index: Number,
    type: String,

    condition: {
      type: [Object],
    },
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      travelPolicyAttributes: this.$store.state.travelPolicy.travelPolicyAttributes,
      selectedAttribute: this.condition.attribute.id?this.condition.attribute.id: "",
      conditions: this.condition,
    };
  },
  methods: {
    valueChanged(event) {
      let date = moment(event);
      this.conditions.comparison.value = date.format("YYYY-MM-DD");
    },

    remove() {
      this.$emit("remove");
    },
    save() {
      const parts = [
        this.selectedTravelAttributeDetails.name,
        this.transformOperator,
        this.transformValue,
      ];
      var messageParts = parts.join(" ");

      this.conditions.message = messageParts;
      this.conditions.attribute.id=this.selectedAttribute;
      this.conditions.attribute.name=this.selectedTravelAttributeDetails.name;

      this.conditions.mode = "view"
      this.isEdit = false;
    },

  },
  mounted() {
    if (this.conditions.mode == "edit") {
      this.isEdit = true;
    }
  },
  computed: {
    selectedTravelAttributeDetails() {
      if (this.selectedAttribute) {
        var item = this.travelPolicyAttributes.find(
          (attr) => attr.id == this.selectedAttribute
        );
        return item;
      }
      return null;
    },
    isList() {
      return (
        this.conditions.comparison.operator == "in" ||
        this.conditions.comparison.operator == "not_in"
      );
    },


    transformOperator() {
      var operatorLabel;
      switch (this.conditions.comparison.operator) {
        case "less_than":
          operatorLabel = "less than";
          break;
        case "greater_than":
          operatorLabel = "greater than";
          break;
        case "equal":
        case "in":

          operatorLabel = "equal to";
          break;
        case "not_equal":
          operatorLabel = "not equal to";
          break;
        case "less_than_inclusive":
          operatorLabel = "<=";
          break;
        case "greater_than_inclusive":
          operatorLabel = "equal to or more than";
          break;
        case "in":
          operatorLabel = "equal to";
          break;
        case "not_in":
          operatorLabel = "not equal to";
          break;

        case "true":
          operatorLabel = "is TRUE";
          break;
        case "false":
          operatorLabel = "is FALSE";
          break;
        default:
          operatorLabel = "";
      }

      return operatorLabel;
    },

    transformValue() {
      var valueUnits = this.conditions.comparison.valueUnits
        ? this.conditions.comparison.valueUnits
        : "";
      var value = this.conditions.comparison.value
        ? this.conditions.comparison.value
        : "";

      var displayValue = value + " ".valueUnits;

      switch (valueUnits) {
     
        case "dollars":
          displayValue = "$" + value;
          break;

        case "days":
          displayValue = value;
          break;
        case "minutes":
          var hours = this.conditions.comparison.value1;
          var mins = this.conditions.comparison.value2;

          displayValue =
            hours + (hours == 1 ? " hour " : " hours ") + mins + " mins";

          break;
        
        case "":
          displayValue = value;
          break;
        // default:
        //   displayValue=value;
      }

      return displayValue;
    },

    isFormValid() {

        var isComparisionOperatorFilled=this.conditions.comparison.operator.length>0;
        var isComparisionValueFilled=this.isDurationField?this.conditions.comparison.value2!=null:this.conditions.comparison.value!=null ;
        var isComparisionUnitsFilled=this.conditions.comparison.valueUnits.length>0;


        if(this.selectedAttribute){
            if(this.selectedTravelAttributeDetails.type=='Boolean')
                return  isComparisionOperatorFilled;
            else{
                if(this.selectedTravelAttributeDetails.units)
                    return isComparisionOperatorFilled && isComparisionValueFilled && isComparisionUnitsFilled;
                else return isComparisionOperatorFilled && isComparisionValueFilled;
                
            }
        }

        return false;
      
    },

   

   

    isDurationField() {
        if(this.selectedAttribute){
            const attr = [
        "Air - In Flight Duration",
        "Air - Journey Duration",
        "Air - Layover Duration",
      ];

      return attr.includes(this.selectedTravelAttributeDetails.name);

        }
        return false;
     
    },

    isNumberField() {
      return (
        !this.isDurationField &&
        this.selectedTravelAttributeDetails.type == "Number"
      );
    },

    valueAsDate() {
      if (this.conditions.comparison.value)
        return moment(this.conditions.comparison.value).toDate();
      else return new Date();
    },

    getTravelAttributes() {
      var item = this.travelPolicyAttributes.filter(
        (attr) => attr.category == this.$helpers.capitalize(this.type)
      );

      return item;
    },
  },
};
</script>

<style scoped>
.is-less-bottom {
  margin-bottom: -20px;
}

.section-heading {
  font-size: 25px;
  margin-bottom: 10px;
  display: block;
  padding: 8px 8px;
  border-bottom: 2px solid;
  margin-bottom: 10px;
}
</style>
